<template>
  <div class="audio-customize" safe-area-inset-bottom>
    <div class="left-img">
      <van-image class="img" :src="require('@/assets/imgs/course/bitmap.png')" fit="cover" />
    </div>

    <div class="center-controls">
      <h4 class="title">{{ title }}</h4>

      <div class="time">
        <span class="cur">{{ cur | timeToStr }}</span>
        <span class="max">{{ max | timeToStr }}</span>
      </div>
      <van-slider v-model="cur" @change="onChange" :max="max">
        <template #button>
          <div class="custom-button"></div>
        </template>
      </van-slider>
    </div>

    <div class="right-controls">
      <van-image class="controls" :src="isPlay ? pause : play" fit="cover" @click="startPlay" />
    </div>

    <!-- <audio ref="audio" :src="require('@/assets/霍勇-中国人民志愿军战歌.mp3')">
      你的浏览器不支持音频播放。
    </audio> -->
    <audio ref="audio" :src="src">
      你的浏览器不支持音频播放。
    </audio>
  </div>
</template>

<script>
const play = require('@/assets/imgs/course/play.png');
const pause = require('@/assets/imgs/course/pause.png');

let timeId;

export default {
  props: ['src', 'title', 'index', 'current'],

  data() {
    return {
      max: 0,
      cur: 0,

      isPlay: false,
      play: play,
      pause: pause
    };
  },

  mounted() {
    this.audio = this.$refs.audio;

    this.initAudio();
  },

  methods: {
    initAudio() {
      // 获取音频的时间，单位s
      setTimeout(() => {
        // 需要加载完成才可以
        const audio = this.audio;
        audio.pause();

        this.stopRecordTime();

        this.max = Math.floor(this.audio.duration);
        this.cur = 0;
        this.isPlay = false;
      }, 100);
    },

    onChange(value) {
      this.audio.currentTime = value;
      this.cur = value;
    },

    startPlay() {
      this.isPlay = !this.isPlay;
      // 这里管理播放与暂停
      const audio = this.audio;
      if (this.cur === this.max) {
        this.isPlay = false;
        this.cur = 0;
      }
      if (this.isPlay) {
        audio.play();
        this.startRecordTime();
      } else {
        audio.pause();
        this.stopRecordTime();
      }
      // 这里要自己计时，要与播放的时间对上
    },

    // 计时
    startRecordTime() {
      clearInterval(timeId);
      timeId = setInterval(() => {
        if (this.current !== this.index) {
          return;
        }
        if (this.cur === this.max) {
          this.stopRecordTime();
        } else {
          // 这里的播放时间控制也是关键的一点，随着暂停与播放，重新计时的话肯定会有问题的
          const currentTime = Math.floor(this.audio.currentTime);
          this.cur = currentTime;
          if (this.cur === this.max) {
            this.startPlay();
          }
        }
      }, 100);
    },
    stopRecordTime() {
      clearInterval(timeId);
    }
  },

  watch: {
    current: {
      handler: function(val, oldVal) {
        console.log(val, oldVal);
        /* ... */
        // if (oldVal) {
        // const audio = this.audio;
        // console.log('audio');
        // console.dir(audio);
        // // debugger;
        // this.initAudio();
        // }
        // 切换隐藏，暂停播放
        if (this.current !== this.index) {
          this.initAudio();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.audio-customize {
  background-color: #fafafa;

  // position: fixed;
  // bottom: 0;
  // left: 0;
  // right: 0;

  padding: 11px 16px;

  height: 72px;
  width: 100%;

  display: flex;
  justify-content: space-around;
  align-items: center;

  .center-controls {
    height: 100%;
    flex: 1;
    margin: 0 24px 0 12px;

    display: flex;
    flex-direction: column;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #262626;
      line-height: 18px;
    }

    .time {
      line-height: 14px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      span {
        font-size: 12px;
        font-weight: 400;
        color: #262626;
        line-height: 14px;
      }
      margin: 6px 0;
    }
  }
  .left-img {
    width: 50px;
    height: 50px;
    .img {
      height: 100%;
      width: 100%;
    }
  }

  .right-controls {
    .controls {
      width: 32px;
      height: 32px;
    }
  }

  .custom-button {
    width: 9px;
    height: 9px;
    background: #ffffff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
    border: 1px solid #e6e6e6;
    border-radius: 5px;
  }
}
</style>

<style lang="less">
.audio-customize {
  .van-slider {
    border-radius: 4px;
    background-color: #d6d6d6;
    &__bar {
      background-color: #3296fa;
    }
  }
}
</style>
